import React from 'react'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom'
import FullscreenIcon from '@mui/icons-material/Fullscreen'
import dayjs from 'dayjs'
import { saveAs } from 'file-saver'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import IconButton from '@mui/material/IconButton'
import { useTheme, useMediaQuery } from '@mui/material'

const TechnicalGraphFilter = ({
  openTable,
  setOpenTable,
  inverterviewbutton,
  technicalToDate,
  technicalFromDate,
  handleChooseDate,
  handleOpen,
  mapInverterSeries,
  value,
  handleChange,
  tabarr,
  isButtonSelected,
  handleButtonClick,
  setTechnicalFromDate,
  setTechnicalToDate,
  setinverterviewbutton,
  handleChangePreiod,
}) => {
  // Remove datepickerDisable state since we want DatePickers always enabled
  console.log('mapInverterSeries', mapInverterSeries)

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const handleselectButton = (ButtonType) => {
    let fromDate,
      toDate = dayjs()

    switch (ButtonType) {
      case 'custom':
        fromDate = technicalFromDate
        toDate = technicalToDate
        break
      case 'YTD':
        fromDate = dayjs().startOf('year')
        break
      case 'MTD':
        fromDate = dayjs().startOf('month')
        break
      case '1Y':
        fromDate = dayjs().subtract(1, 'year')
        break
      case '6M':
        fromDate = dayjs().subtract(6, 'month')
        break
      case '3M':
        fromDate = dayjs().subtract(3, 'month')
        break
      case '1M':
        fromDate = dayjs().subtract(1, 'month')
        break
      case 'day':
        fromDate = dayjs()
        break
      default:
        fromDate = technicalFromDate
        break
    }

    setTechnicalFromDate(fromDate)
    setTechnicalToDate(toDate)
    setinverterviewbutton(ButtonType)
    handleChangePreiod(ButtonType)
  }

  // Modified to handle date changes and switch to custom mode
  const handleDateChange = (value, type) => {
    // Call handleChooseDate to sync with parent FIRST
    handleChooseDate(value, type)

    // Update local state
    if (type === 'from') {
      setTechnicalFromDate(value)
    } else {
      setTechnicalToDate(value)
    }

    // Switch to custom mode
    setinverterviewbutton('custom')
  }

  const exportToCSV = (rows) => {
    console.log('rowsrows', rows)

    if (!rows || rows.length === 0) {
      console.log('No data to export - rows is empty or undefined')
      alert(
        'No data available to export. Please select some data series first.'
      )
      return
    }

    try {
      // Validate that rows have the expected structure
      const validRows = rows.filter((row) => {
        const isValid = row && typeof row === 'object' && row.name
        if (!isValid) {
          console.warn('Invalid row detected:', row)
        }
        return isValid
      })

      if (validRows.length === 0) {
        console.log('No valid rows found after filtering')
        alert('No valid data series found to export.')
        return
      }

      console.log('Valid rows for export:', validRows.length)

      // Create headers with better formatting
      const headings = ['Date/Time']
      const seriesInfo = []

      validRows.forEach((item, index) => {
        const seriesName = item.name || `Series ${index + 1}`
        const unit = item.unit || ''
        const headerName = unit ? `${seriesName} (${unit})` : seriesName
        headings.push(headerName)

        seriesInfo.push({
          name: seriesName,
          unit: unit,
          dataCount:
            item.data && Array.isArray(item.data) ? item.data.length : 0,
        })
      })

      console.log('Series info:', seriesInfo)

      // Improved function to parse and format dates consistently
      const parseDateAndFormat = (dateValue, period) => {
        if (!dateValue) return { formatted: 'Unknown Date', sortValue: 0 }

        try {
          let dayjsObj

          // Handle different input formats
          if (typeof dateValue === 'string') {
            // Check if it's in DD-MM-YYYY format
            const ddmmyyyyMatch = dateValue.match(
              /^(\d{1,2})-(\d{1,2})-(\d{4})$/
            )
            if (ddmmyyyyMatch) {
              const [, day, month, year] = ddmmyyyyMatch
              dayjsObj = dayjs(
                `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
              )
            }
            // Check if it's in MM/DD/YYYY format and convert
            else if (dateValue.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)) {
              const [, month, day, year] = dateValue.match(
                /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/
              )
              dayjsObj = dayjs(
                `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
              )
            }
            // Check if it's in YYYY-MM-DD format
            else if (dateValue.match(/^\d{4}-\d{1,2}-\d{1,2}$/)) {
              dayjsObj = dayjs(dateValue)
            }
            // Try parsing as-is
            else {
              dayjsObj = dayjs(dateValue)
            }
          } else {
            dayjsObj = dayjs(dateValue)
          }

          if (dayjsObj.isValid()) {
            // Always return DD-MM-YYYY format for consistency
            let formatted
            switch (period) {
              case 'day':
                formatted = dayjsObj.format('DD-MM-YYYY HH:mm')
                break
              case 'custom':
                // Check if we have hour/minute data
                if (dayjsObj.hour() !== 0 || dayjsObj.minute() !== 0) {
                  formatted = dayjsObj.format('DD-MM-YYYY HH:mm')
                } else {
                  formatted = dayjsObj.format('DD-MM-YYYY')
                }
                break
              case '1M':
              case 'MTD':
              case '3M':
              case '6M':
              case '1Y':
              case 'YTD':
              default:
                formatted = dayjsObj.format('DD-MM-YYYY')
                break
            }

            return {
              formatted: formatted,
              sortValue: dayjsObj.valueOf(),
            }
          } else {
            // Handle non-date strings
            const dateStr = String(dateValue)

            // Check if it's a month name or number
            if (
              /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i.test(
                dateStr
              )
            ) {
              return { formatted: dateStr, sortValue: 0 }
            }

            // Check if it's a year
            if (/^\d{4}$/.test(dateStr)) {
              return {
                formatted: `Year ${dateStr}`,
                sortValue: parseInt(dateStr),
              }
            }

            // Check if it's just a month number
            if (
              /^\d{1,2}$/.test(dateStr) &&
              parseInt(dateStr) >= 1 &&
              parseInt(dateStr) <= 12
            ) {
              const monthNames = [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec',
              ]
              return {
                formatted: monthNames[parseInt(dateStr) - 1] || dateStr,
                sortValue: parseInt(dateStr),
              }
            }

            return { formatted: dateStr, sortValue: 0 }
          }
        } catch (error) {
          console.warn(`Error formatting date ${dateValue}:`, error)
          return { formatted: String(dateValue), sortValue: 0 }
        }
      }

      // Collect all timestamps with better validation and sorting
      const timestampValueMap = new Map()
      let totalDataPoints = 0

      validRows.forEach((item, seriesIndex) => {
        if (!item.data || !Array.isArray(item.data)) {
          console.warn(`Series ${seriesIndex} has no data array:`, item)
          return
        }

        item.data.forEach((dataPoint, pointIndex) => {
          if (!dataPoint || typeof dataPoint !== 'object') {
            return
          }

          if (dataPoint.x === undefined || dataPoint.x === null) {
            return
          }

          // Parse and format the timestamp consistently
          const { formatted, sortValue } = parseDateAndFormat(
            dataPoint.x,
            inverterviewbutton
          )

          if (!timestampValueMap.has(formatted)) {
            timestampValueMap.set(formatted, {
              sortValue: sortValue,
              data: new Map(),
            })
          }

          // Store the y value for this series at this timestamp
          const yValue =
            dataPoint.y !== undefined && dataPoint.y !== null ? dataPoint.y : 0
          timestampValueMap.get(formatted).data.set(item.name, yValue)
          totalDataPoints++
        })
      })

      if (timestampValueMap.size === 0) {
        console.log('No valid timestamps found')
        alert('No valid data points found to export.')
        return
      }

      console.log(
        `Found ${timestampValueMap.size} unique timestamps with ${totalDataPoints} total data points`
      )

      // Sort timestamps chronologically
      const sortedTimestamps = Array.from(timestampValueMap.keys()).sort(
        (a, b) => {
          const aSort = timestampValueMap.get(a).sortValue
          const bSort = timestampValueMap.get(b).sortValue
          return aSort - bSort
        }
      )

      // Build CSV rows
      const csvRows = []

      // Add header
      csvRows.push(headings.join(','))

      // Add data rows
      sortedTimestamps.forEach((timestamp) => {
        const timestampData = timestampValueMap.get(timestamp)
        const rowData = [timestamp]

        validRows.forEach((item) => {
          const value = timestampData.data.get(item.name)
          let formattedValue = '0'

          if (value !== undefined && value !== null) {
            const numValue = parseFloat(value)
            if (!isNaN(numValue)) {
              // Format number to avoid scientific notation and limit to 2 decimal places
              formattedValue = numValue.toFixed(2)
            } else {
              formattedValue = String(value)
            }
          }

          rowData.push(formattedValue)
        })

        csvRows.push(rowData.join(','))
      })

      // Create CSV content
      const csvContent = csvRows.join('\n')

      // Add BOM for Excel compatibility
      const BOM = '\uFEFF'
      const finalContent = BOM + csvContent

      // Create blob and download
      const blob = new Blob([finalContent], {
        type: 'text/csv;charset=utf-8',
      })

      const currentDate = dayjs().format('YYYY-MM-DD_HH-mm-ss')
      const periodLabel = inverterviewbutton.toUpperCase()
      const filename = `TechnicalView_${periodLabel}_${currentDate}.csv`

      saveAs(blob, filename)

      console.log(`CSV exported successfully: ${filename}`)
      console.log(
        `Exported ${sortedTimestamps.length} rows with ${validRows.length} data series`
      )
    } catch (error) {
      console.error('=== CSV Export Error ===')
      console.error('Error details:', error)
      console.error('Stack trace:', error.stack)
      alert('An error occurred while exporting the CSV. Please try again.')
    }
  }

  const datePickerStyle = {
    width: '130px',
  }

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    }
  }

  const timeFilters = [
    { label: 'CUST', value: 'custom' },
    { label: 'YTD', value: 'YTD' },
    { label: 'MTD', value: 'MTD' },
    { label: '1Y', value: '1Y' },
    { label: '6M', value: '6M' },
    { label: '3M', value: '3M' },
    { label: '1M', value: '1M' },
    { label: 'TODAY', value: 'day' },
  ]

  return (
    <div className="technical-graph-filter">
      {isMobile ? (
        <Stack spacing={2} sx={{ mb: 2, overflow: 'visible' }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ px: 1 }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <div className="check_graph">
                <input
                  id="TechnicalViewGraph"
                  type="checkbox"
                  checked={openTable}
                  onChange={(e) => setOpenTable(!openTable)}
                />
                <label htmlFor="TechnicalViewGraph"></label>
              </div>
            </Box>
            <Stack direction="row" spacing={1} alignItems="center">
              {openTable && (
                <IconButton
                  size="small"
                  onClick={() => exportToCSV(mapInverterSeries)}
                  sx={{ color: 'primary.main' }}
                >
                  <VerticalAlignBottomIcon fontSize="small" />
                </IconButton>
              )}
              <IconButton
                size="small"
                onClick={handleOpen}
                sx={{ color: 'primary.main' }}
              >
                <FullscreenIcon fontSize="small" />
              </IconButton>
            </Stack>
          </Stack>

          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            sx={{ px: 1, py: 0.5 }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <DatePicker
                  label="From Date"
                  minDate={dayjs(new Date()).subtract(2, 'year')}
                  maxDate={technicalToDate}
                  format="DD-MM-YYYY"
                  value={technicalFromDate}
                  onChange={(value) => handleDateChange(value, 'from')}
                  slotProps={{
                    textField: {
                      size: 'small',
                      fullWidth: true
                    }
                  }}
                />
              </Box>
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <DatePicker
                  label="To Date"
                  minDate={technicalFromDate}
                  maxDate={dayjs()}
                  format="DD-MM-YYYY"
                  value={technicalToDate}
                  onChange={(value) => handleDateChange(value, 'to')}
                  slotProps={{
                    textField: {
                      size: 'small',
                      fullWidth: true
                    }
                  }}
                />
              </Box>
            </LocalizationProvider>
          </Stack>

          <Box
            sx={{
              overflowX: 'auto',
              overflowY: 'visible',
              whiteSpace: 'nowrap',
              px: 1,
              pt: 0.5,
              pb: 2,
              mb: 1,
              minHeight: 56,
              display: 'flex',
              alignItems: 'center',
              '&::-webkit-scrollbar': { height: 6 },
              '&::-webkit-scrollbar-thumb': { bgcolor: 'rgba(0,0,0,0.2)', borderRadius: 3 }
            }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="graph data type filters"
              sx={{
                minHeight: 40,
                '& .MuiTab-root': {
                  minHeight: 40,
                  minWidth: 'auto',
                  px: 2,
                  py: 1
                }
              }}
            >
              <Tab
                label="Inverter Energy"
                style={
                  isButtonSelected('Inverter Energy')
                    ? {
                      backgroundColor: 'rgb(89 104 183 / 50%)',
                      textTransform: 'none',
                    }
                    : { textTransform: 'none' }
                }
                onClick={() => handleButtonClick('Inverter Energy', '', 1)}
              />
              <Tab
                label="Meter Energy"
                style={
                  isButtonSelected('Meter Energy')
                    ? {
                      backgroundColor: 'rgb(89 104 183 / 50%)',
                      textTransform: 'none',
                    }
                    : { textTransform: 'none' }
                }
                onClick={() => handleButtonClick('Meter Energy', '', 1)}
              />
              <Tab
                label="GHI"
                style={
                  isButtonSelected('GHI')
                    ? {
                      backgroundColor: 'rgb(89 104 183 / 50%)',
                      textTransform: 'none',
                    }
                    : { textTransform: 'none' }
                }
                onClick={() => handleButtonClick('GHI', '', 1)}
              />
              <Tab
                label="GTI"
                style={
                  isButtonSelected('GTI')
                    ? {
                      backgroundColor: 'rgb(89 104 183 / 50%)',
                      textTransform: 'none',
                    }
                    : { textTransform: 'none' }
                }
                onClick={() => handleButtonClick('GTI', '', 1)}
              />
              <Tab
                label="Active Power"
                style={
                  isButtonSelected('Active Power')
                    ? {
                      backgroundColor: 'rgb(89 104 183 / 50%)',
                      textTransform: 'none',
                    }
                    : { textTransform: 'none' }
                }
                onClick={() => handleButtonClick('Active Power', '', 1)}
              />
            </Tabs>
          </Box>

          <Stack
            direction="row"
            spacing={1}
            sx={{
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              px: 1,
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
              '&::-webkit-scrollbar': { display: 'none' }
            }}
          >
            {timeFilters.map((filter) => (
              <Box
                key={filter.value}
                className={
                  inverterviewbutton === filter.value
                    ? 'day_s_bottomline'
                    : 'day_s_b'
                }
                onClick={() => handleselectButton(filter.value)}
                sx={{
                  flexShrink: 0,
                  cursor: 'pointer'
                }}
              >
                {filter.label}
              </Box>
            ))}
          </Stack>
        </Stack>
      ) : (
        //desktop layout
        <>
          <div className="align_btw mb_6">
            <div>
              <div className="h_txt1">Technical View</div>
            </div>
            <div>
              <div className="align_end">
                <div className="check_graph mr_8">
                  <input
                    id="TechnicalViewGraph"
                    type="checkbox"
                    checked={openTable}
                    onChange={(e) => setOpenTable(!openTable)}
                  />
                  <label htmlFor="TechnicalViewGraph"></label>
                </div>
                <div className="mr_8">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DatePicker']}>
                      <div style={datePickerStyle}>
                        <DatePicker
                          label="From Date"
                          minDate={dayjs(new Date()).subtract(2, 'year')}
                          maxDate={technicalToDate}
                          format="DD-MM-YYYY"
                          value={technicalFromDate}
                          onChange={(value) => handleDateChange(value, 'from')}
                        // Remove disabled prop to allow date selection always
                        />
                      </div>
                    </DemoContainer>
                  </LocalizationProvider>
                </div>
                <div className="mr_8">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DatePicker']}>
                      <div style={datePickerStyle}>
                        <DatePicker
                          label="To Date"
                          minDate={technicalFromDate}
                          maxDate={dayjs()}
                          format="DD-MM-YYYY"
                          value={technicalToDate}
                          onChange={(value) => handleDateChange(value, 'to')}
                        // Remove disabled prop to allow date selection always
                        />
                      </div>
                    </DemoContainer>
                  </LocalizationProvider>
                </div>
                {openTable && (
                  <div className="mr_8">
                    <VerticalAlignBottomIcon
                      className="i_clr pointer"
                      onClick={() => exportToCSV(mapInverterSeries)}
                    />
                  </div>
                )}
                <div>
                  <FullscreenIcon className="i_clr pointer" onClick={handleOpen} />
                </div>
              </div>
            </div>
          </div>

          <div className="align_btw mb_6">
            <div>
              <Box
                sx={{ maxWidth: { xs: 220, sm: 250 }, bgcolor: 'background.paper' }}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="scrollable auto tabs example"
                >
                  {tabarr.map((index) => (
                    <React.Fragment key={index}>
                      <Tab
                        label="Inverter Energy"
                        {...a11yProps(11)}
                        style={
                          isButtonSelected('Inverter Energy')
                            ? {
                              backgroundColor: 'rgb(89 104 183 / 50%)',
                              textTransform: 'none',
                            }
                            : { textTransform: 'none' }
                        }
                        onClick={() => handleButtonClick('Inverter Energy', '', 1)}
                      />
                      <Tab
                        label="Meter Energy"
                        {...a11yProps(31)}
                        style={
                          isButtonSelected('Meter Energy')
                            ? {
                              backgroundColor: 'rgb(89 104 183 / 50%)',
                              textTransform: 'none',
                            }
                            : { textTransform: 'none' }
                        }
                        onClick={() => handleButtonClick('Meter Energy', '', 1)}
                      />
                      <Tab
                        label="GHI"
                        {...a11yProps(41)}
                        style={
                          isButtonSelected('GHI')
                            ? {
                              backgroundColor: 'rgb(89 104 183 / 50%)',
                              textTransform: 'none',
                            }
                            : { textTransform: 'none' }
                        }
                        onClick={() => handleButtonClick('GHI', '', 1)}
                      />
                      <Tab
                        label="GTI"
                        {...a11yProps(51)}
                        style={
                          isButtonSelected('GTI')
                            ? {
                              backgroundColor: 'rgb(89 104 183 / 50%)',
                              textTransform: 'none',
                            }
                            : { textTransform: 'none' }
                        }
                        onClick={() => handleButtonClick('GTI', '', 1)}
                      />
                      <Tab
                        label="Active Power"
                        {...a11yProps(61)}
                        style={
                          isButtonSelected('Active Power')
                            ? {
                              backgroundColor: 'rgb(89 104 183 / 50%)',
                              textTransform: 'none',
                            }
                            : { textTransform: 'none' }
                        }
                        onClick={() => handleButtonClick('Active Power', '', 1)}
                      />
                    </React.Fragment>
                  ))}
                </Tabs>
              </Box>
            </div>
            <div className="time-filters">
              {timeFilters.map((filter) => (
                <div
                  key={filter.value}
                  className={
                    inverterviewbutton === filter.value
                      ? 'day_s_bottomline'
                      : 'day_s_b'
                  }
                  onClick={() => handleselectButton(filter.value)}
                >
                  {filter.label}
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default TechnicalGraphFilter
